var _span;
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { deprecate } from 'react-is-deprecated';
import Button from '../Button/index.js';
import Glyphicon from '../Glyphicon/index.js';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const defaultPrev = /*#__PURE__*/_jsx(Glyphicon, {
  glyph: "menu-left"
});
const defaultNext = /*#__PURE__*/_jsx(Glyphicon, {
  glyph: "menu-right"
});
function Pagination(_ref) {
  let {
    id,
    activePage = 1,
    items = 1,
    maxButtons = 0,
    onClick,
    ellipsis,
    className,
    prev = defaultPrev,
    next = defaultNext,
    onSelect
  } = _ref;
  // deprecate onSelect
  const onPageClick = onSelect || onClick;
  const handleOnClick = (page, event) => {
    event.preventDefault();
    return onPageClick && onPageClick(page, event);
  };
  const renderPageButton = (page, name, node) => {
    const isActivePage = page === activePage;
    return /*#__PURE__*/_jsx("li", {
      className: isActivePage ? 'active' : null,
      children: page?.toString().includes('ellipsis') ? _span || (_span = /*#__PURE__*/_jsx("span", {
        children: '\u2026'
      })) : /*#__PURE__*/_jsxs(Button, {
        onClick: event => handleOnClick(page, event),
        "aria-label": name ? `${name} Page` : `Page ${page}`,
        "aria-current": isActivePage ? 'page' : null,
        children: [!isActivePage && /*#__PURE__*/_jsx("span", {
          className: "sr-only",
          children: `${name ?? ''} Page`
        }), node || page]
      })
    }, name ? `${name.toString().toLowerCase()}Page` : page);
  };
  const renderPaginationButtons = () => {
    const pageButtons = [];
    let startPage;
    let endPage;
    if (maxButtons && maxButtons < items) {
      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
      endPage = startPage + maxButtons - 1;
    } else {
      startPage = 1;
      endPage = items;
    }
    if (ellipsis && startPage > 1) {
      pageButtons.push(1);
      if (startPage > 2) {
        pageButtons.push('ellipsisFirst');
      }
    }
    for (let page = startPage; page <= endPage; page += 1) {
      pageButtons.push(page);
    }
    if (ellipsis && endPage < items) {
      if (endPage < items - 1) {
        pageButtons.push('ellipsisLast');
      }
      pageButtons.push(items);
    }
    return pageButtons.map(page => renderPageButton(page));
  };
  return /*#__PURE__*/_jsxs("ul", {
    "data-cmp": "pagination",
    className: clsx(className, 'pagination'),
    "aria-label": "Pagination for Search Result",
    role: "navigation",
    id: id ?? 'pagination',
    children: [activePage !== 1 && renderPageButton(activePage - 1, 'Previous', prev), renderPaginationButtons(), activePage !== items && renderPageButton(activePage + 1, 'Next', next)]
  });
}
export default Pagination;